import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { CONTACT } from '../data/site';

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* WhatsApp — always visible */}
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label="Contact WhatsApp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-emerald_ink text-white flex items-center justify-center shadow-lg shadow-emerald_ink/25 hover:scale-110 transition-transform"
        data-testid="whatsapp-fab"
      >
        <MessageCircle size={22} strokeWidth={1.6} />
        <span className="absolute inset-0 rounded-full ring-1 ring-emerald_ink/40 animate-ping" />
      </a>

      {/* Devis CTA — appears on scroll */}
      <AnimatePresence>
        {visible && (
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.5 }}
            onClick={scrollToContact}
            className="fixed bottom-6 right-24 z-40 hidden md:inline-flex items-center gap-2 bg-gold text-cream px-5 py-3 text-[11px] tracking-[0.2em] uppercase hover:bg-char transition-colors"
            data-testid="floating-devis"
          >
            Demander un devis
            <ArrowRight size={14} />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
